import { defineCustomElement } from 'vue';
import Filtro from '../../../src/vue/shared/filtro/Main.vue';
import plugins from '../../../src/vue/shared/filtro/plugins';
try {
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('novo-filtro')) {
      const FiltroElement = defineCustomElement(Filtro, {
        shadowRoot: false,
        configureApp(app) {
          app.use(plugins);
        }
      });
      customElements.define('novo-filtro', FiltroElement);
    }
  });
} catch (error) {
  console.error('Falha ao definir o componente customizado:', error);
}
